import React, { useContext, useLayoutEffect } from 'react';
import cx from 'classnames';
import NAV_DATA, {
  PrimaryNavIdentifier,
} from '@zola-helpers/client/dist/es/constants/navConstants';
import { useEffectOnce } from '@zola/zola-ui/src/hooks';

import type { NavPrimaryMapStateProps } from 'components/navV2/NavPrimary';
import NavMapper from 'components/navV2/NavMapper';
import { UniversalTabs } from 'reducers/nav';
import NavContext from 'components/navV2/NavScrollContainer/context';
import NavPrimaryMapper from 'components/navV2/NavPrimary/NavPrimaryMapper';

import preFetchMarketingImages from 'util/preFetchMarketingImages';

import { PrimaryNavData } from '../NavData/types';
import * as MegaMenusConstants from '../../../util/constants/megaMenuModuleGroups';

import './navPrimary.less';

type NavPrimaryProps = NavPrimaryMapStateProps & {
  primaryNavData: PrimaryNavData[];
  activeLinkId?: PrimaryNavIdentifier | '';
  moduleGroups?: unknown[];
  handleFetchModuleGroups: () => void;
  activeUniversalTab?: string;
};
const NavPrimary = ({
  primaryNavData = [],
  activeLinkId,
  moduleGroups = [],
  handleFetchModuleGroups,
  activeUniversalTab,
  userContext,
}: NavPrimaryProps): JSX.Element => {
  useEffectOnce(() => {
    handleFetchModuleGroups();
    window.dispatchEvent(new CustomEvent(NAV_DATA.EVENTS.NAV_PRIMARY_RENDERED));
  });

  useLayoutEffect(() => {
    if (moduleGroups.length) {
      /**
       * for vendor marketplace: the order of the modules shown is determined by an A/B test
       */
      const marketplaceModuleGroup = moduleGroups.find(
        ({ tag }) => tag === MegaMenusConstants.MEGA_MENU_VENDORS
      );
      if (marketplaceModuleGroup && marketplaceModuleGroup.moduleViews) {
        const { moduleViews } = marketplaceModuleGroup;
        const VENDORS_1 = moduleViews.find(({ title }) => title === 'MEGA_MENU_VENDORS_1');
        const VENDORS_2 = moduleViews.find(({ title }) => title === 'MEGA_MENU_VENDORS_2');

        if (VENDORS_1 && VENDORS_2) {
          marketplaceModuleGroup.moduleViews = [VENDORS_1, VENDORS_2];
        }
      }

      preFetchMarketingImages(moduleGroups);
    }
  }, [moduleGroups, userContext]);

  const isHomeStoreActive = activeUniversalTab === UniversalTabs.HOME_STORE;
  let finalLinkId = activeLinkId;
  if (
    !activeLinkId &&
    window &&
    window.location &&
    window.location.pathname.indexOf('/expert-advice') > -1
  ) {
    finalLinkId = NAV_DATA.PRIMARY.ADVICE;
  }

  const { hidePrimarySection } = useContext(NavContext);
  const classes = cx('nav-section', { 'nav-section--hide': hidePrimarySection });
  return !isHomeStoreActive ? (
    <NavPrimaryMapper
      navData={primaryNavData}
      className={classes}
      activeLinkId={finalLinkId}
      userContext={userContext}
    />
  ) : (
    // Render the home store nav as a secondary nav menu
    <NavMapper
      navData={primaryNavData}
      type="Primary"
      className={classes}
      activeLinkId={activeLinkId}
    />
  );
};

export default NavPrimary;
